import React from 'react';
import { FormInputProps } from '../../types/shared/FormInputProps';
import ActionButton from '../button/ActionButton';
import ButtonRow from '../button/ButtonRow';
import FormField from '../form/FormField';
import FileUpload from './FileUpload';
import useFilePicker from './hooks/useFilePicker';
import LargeFileUpload from './LargeFileUpload';

interface FilePickerProps extends FormInputProps<string[] | null> {
    maxFiles?: number;
    apiURL: string;
    buttonColor?: string | undefined;
    buttonExtraClasses?: string;
    storageURL: string;
    label?: string;
    acceptedTypes?: string;
    isWebArea?: boolean;
    largeFile?: boolean;
}
// todo make filepicker handle single file upload better
const FilePicker: React.FC<FilePickerProps> = ({
    name,
    label,
    required,
    customValidate,
    value,
    maxFiles = 1,
    apiURL,
    buttonColor = 'blue',
    buttonExtraClasses = '',
    storageURL,
    onChange,
    acceptedTypes,
    isWebArea,
    largeFile,
}) => {
    let source;

    const {
        inputRef,
        filePicker,
        error,
        handleAddFileClick,
        handleUpload,
        handleDelete,
        handleCancel,
        organizeS3KeysByType,
        handleUploadLargeFile,
    } = useFilePicker({
        name,
        required,
        customValidate,
        value,
        source,
        maxFiles,
        apiURL,
        onChange,
        acceptedTypes,
    });

    const { fileS3Keys, progress, uploadingFileName, softError } = filePicker;

    return (
        <>
            <FormField name={name} label={label} required={required} error={error}>
                <div className={`file-drop-container size-lg-12`}>
                    {fileS3Keys && fileS3Keys.length < maxFiles && (
                        <ButtonRow>
                            <ActionButton
                                type="button"
                                color={buttonColor}
                                onClick={handleAddFileClick}
                                disabled={progress !== null}
                            >
                                Browse
                            </ActionButton>
                        </ButtonRow>
                    )}

                    {!largeFile ? (
                        <FileUpload
                            name={name}
                            maxFiles={maxFiles}
                            fileS3Keys={fileS3Keys}
                            organizeS3KeysByType={organizeS3KeysByType}
                            inputRef={inputRef}
                            handleUpload={handleUpload}
                            handleDelete={handleDelete}
                            handleCancel={handleCancel}
                            progress={progress}
                            uploadingFileName={uploadingFileName}
                            storageURL={storageURL}
                        />
                    ) : (
                        <LargeFileUpload
                            name={name}
                            maxFiles={maxFiles}
                            fileS3Keys={fileS3Keys}
                            organizeS3KeysByType={organizeS3KeysByType}
                            inputRef={inputRef}
                            handleUpload={handleUploadLargeFile}
                            handleDelete={handleDelete}
                            handleCancel={handleCancel}
                            progress={progress}
                            uploadingFileName={uploadingFileName}
                            storageURL={storageURL}
                        />
                    )}
                </div>
            </FormField>
            {!!softError && <p className="form-error red-text text-accent-4">{softError}</p>}
        </>
    );
};

export default FilePicker;
